import { PivotBasic } from './PivotBasic';
import { PivotDetail } from './PivotDetail';
export var PivotPlan;
(function (PivotPlan) {
    function make(model, viewName, pivot) {
        switch (pivot.type) {
            case "BASIC":
                return PivotBasic.make(model, viewName, pivot);
            case "DETAIL":
                if ((pivot.series || []).length === 0) {
                    return PivotBasic.make(model, viewName, pivot);
                }
                else {
                    return PivotDetail.make(model, viewName, pivot);
                }
        }
    }
    PivotPlan.make = make;
})(PivotPlan || (PivotPlan = {}));
